import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { breakpoints } from '../helpers/breakpoints';

const StyledInfoBlock = styled.div`
  background: ${props => (props.bgColour ? props.bgColour : 'var(--c-purple)')};
  border-radius: var(--border-radius);
  padding: 2.5rem;
  margin-bottom: var(--v-spacing);
  cursor: ${props => (props.onClick ? 'pointer' : 'auto')};
  h3,
  p {
    color: var(--c-white);
  }
  h3 {
    font-size: 3.4rem;
    margin-bottom: 1rem;
  }
  img {
    width: 4rem;
    height: auto;
    margin-bottom: 1rem;
  }
`;

const InfoBlock = props => {
  const { as, to, children, className, bgColour, onClick } = props;
  return (
    <StyledInfoBlock bgColour={bgColour} as={as} className={className} to={to} onClick={onClick}>
      {children}
    </StyledInfoBlock>
  );
};

export default InfoBlock;
